import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import './styles.css';
import { sxCloseIconButton, sxTypographySubTitleModal, sxTypographyTitleModal } from './sxProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';


const ModalAtendimentoCancelado: React.FC<{
    showModal: boolean;
    handleShowModal: () => void;
    onComplete: () => void;
}> = ({ showModal, handleShowModal, onComplete }) => {

    const accessibility = useAccessibility();

    const closeModal = () => {
        handleShowModal();
        onComplete();
    }
    
    return (
        <div>
            <Modal
                open={showModal}
                onClose={closeModal}
            >
                <div className='container-schedule-modal' style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }} >
                    <IconButton
                        aria-label="fechar"
                        onClick={closeModal}
                        sx={sxCloseIconButton}
                    >
                        <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faTimes} size="1x" color='black' />
                    </IconButton>
                    <div>
                        <Typography component="h1" color="#383838" style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographyTitleModal}>Cancelado</Typography>
                        <Typography color="#4C4C4C" style={accessibility.textStyleAccessibility} tabIndex={0} sx={sxTypographySubTitleModal}>Seu atendimento foi cancelado com sucesso!</Typography>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ModalAtendimentoCancelado;
